module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/near-by.component.css
// module id = ./src/app/near-by.component.css
// module chunks = main